<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="/corporate//marketing-tool">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Prompt's List</li>
    </ol>
  </nav>
</div>
<div class="container mt-2 themeTblReso position-relative z-in99">
  <div class="d-flex mb-2 align-items-center flex-wrap" style="gap: 10px">
    <div class="flex-grow-1">
      <select
        class="form-control formstyle"
        [(ngModel)]="companyID"
        (change)="onCompanyChange($event)"
      >
        <option value="0" disabled>Select Company Name</option>
        <option
          *ngFor="let userObj of getJourneyObj"
          value="{{ userObj.customer_id }}"
        >
          {{ userObj.customer_company_name }}
        </option>
      </select>
    </div>
    <div class="flex-grow-1">
      <select
        class="form-control formstyle"
        [(ngModel)]="promptStatusVal"
        (change)="onStatusFilterChange($event)"
      >
        <option value="0" disabled>Select Status</option>
        <option
          *ngFor="let userObj of promptStatusObj"
          value="{{ userObj.value }}"
        >
          {{ userObj.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="row1 mt-1">
    <div id="no-more-tables">
      <table class="cf bdrStCustom accordSmall" style="width: 100%">
        <thead class="cf">
          <tr>
            <th>Prompt's</th>
            <th>Created On</th>
            <th>DS Enable</th>
            <th style="text-align: start">Action</th>
          </tr>
        </thead>
        <tbody *ngFor="let obj of promptObj">
          <tr id="{{ obj.id }}" class="multi-collapse">
            <td data-title="Journey Name">
              <div class="prompt-text" [class.collapsed]="!isExpanded(obj.id)">
                {{ obj.prompt }}
              </div>
              <a *ngIf="obj.prompt && obj.prompt.length > 213" href="javascript:void(0);" class="view-more-link" (click)="toggleExpand(obj.id)">
                {{ isExpanded(obj.id) ? 'View Less' : 'View More' }}
              </a>
            </td>
            <td data-title="Created On" style="min-width: 130px;">{{ obj.created_on | date }}</td>
            <td data-title="DS Enable">
              <div class="d-flex align-items-center action-btns">
                  <button
                    type="button"
                    [class.active]="obj.is_ds_enabled"
                    [class.inactive]="!obj.is_ds_enabled"
                    class="btn btn-sm active-toggle p-0"
                    (click)="onStatusChange(obj, 'ds')"
                  >
                    <i [class]="obj.is_ds_enabled ? 'bi-toggle2-on' : 'bi-toggle2-off'" class="bi"></i>
                  </button>
              </div>
            </td>
            <td data-title="Action">
              <div class="d-flex align-items-center action-btns">
                <button
                  type="button"
                  [class.active]="obj.is_active"
                  [class.inactive]="!obj.is_active"
                  class="btn btn-sm active-toggle p-0"
                  (click)="onStatusChange(obj, 'active' )"
                >
                  <i [class]="obj.is_active ? 'bi-toggle2-on' : 'bi-toggle2-off'" class="bi"></i>
                </button>
                <button
                  class="btn action-btn delete"
                  type="button"
                  ngbTooltip="Delete"
                  placement="top"
                >
                  <i
                    class="fa fa-trash mr-2 linkForce"
                    (click)="deletePromptRecord(obj.id)"
                  ></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="promptObj.length === 0" style="text-align: center">
        <p>No Result Available</p>
      </div>
    </div>
  </div>
  <div class="mt-2 text-center difPagination" *ngIf="totalCount > 10">
    <ngb-pagination
      [collectionSize]="totalCount"
      [(page)]="page"
      [maxSize]="2"
      [rotate]="true"
      (pageChange)="getCompanyData((page = $event))"
      aria-label="Custom pagination"
    >
      <ng-template ngbPaginationPrevious>Prev</ng-template>
      <ng-template ngbPaginationNext>Next</ng-template>
    </ngb-pagination>
  </div>
</div>
